import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  gatewayFormValidator,
  gatewayFormValidatorWithCustomErrors,
  VALIDATORS,
} from "../../../../utils/gatewayFormValidator";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import QRCodeCard from "../../../../utils/QrCodeCard";
import {
  updateDepositAmount,
  createDeposit,
  getOneGateway,
} from "../../../../redux/user/actions";
import { APP_CONST } from "../../../../config/const";
import { Toaster } from "../../../../utils/toaster";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";
import { Container } from "react-bootstrap";
import { Navigate, useParams, useNavigate } from "react-router-dom";
import { getActiveBankDetails } from "../../../../redux/app/actions";
// import CopyToClipboard from "../../../components/copyToClipBoard";
import CopyToClipboard from "react-copy-to-clipboard";
import { AiFillCopy } from "react-icons/ai";
import CrossBtn from "../../../../assets/images/icons/close_btn-icon.png";
import BackIcon from "../../../../assets/svg/BackIcon";
import load from "../../../../assets/images/icons/load.gif";
import DisplayValues from "../../../components/gateways/DisplayValues";
const CUSTOM_DEPOSIT_RESPONSE_TYPE = {
  QRCODE: "QRCODE",
  IMAGE: "IMAGE",
};
const DepositGateway = () => {
  const navigate = useNavigate();
  const { gatewaysList } = useSelector((state) => state.user);
  const { bankDetails } = useSelector((state) => state.app);
  const { user } = useSelector((state) => state.auth);
  const isDemoUser = user?.mstruserid === process.env.REACT_APP_DEMO_USER_ID;
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [selectedGateway, setSelectedGateway] = useState(null);
  const [errors, setErrors] = useState({});
  const { gateway } = useParams();
  const isBank = gateway === "bank_transfer";
  const showQrImg = selectedGateway?.qrCode !== null;
  const [disable, setDisable] = useState(false);
  const [customdepositResponseType, setCustomDepositResponseType] =
    useState(null);
  const [customActionDepositResponse, setCustomActionDepositResponse] =
    useState(null);

  useEffect(() => {
    if (gateway !== "bank_transfer") {
      getOneGtwFromServer(gateway);
    } else {
      dispatch(getActiveBankDetails());
    }
  }, [gateway]);

  const getOneGtwFromServer = async (gtw) => {
    const response = await getOneGateway(gtw);
    setSelectedGateway(response?.data?.data);
  };

  const validateData = (dataToValidate) => {
    let fields = selectedGateway.fields;
    let validations = gatewayFormValidatorWithCustomErrors({
      fields: fields,
      dataToValidate: dataToValidate,
      cstmValidation: {
        amount: [
          {
            validationValue: selectedGateway?.depositSettings?.min,
            type: VALIDATORS.Min,
            customMessage: `Min allowed amount is ${selectedGateway?.depositSettings?.min}`,
          },
          {
            validationValue: selectedGateway?.depositSettings?.max,
            type: VALIDATORS.Max,
            customMessage: `Max allowed amount is ${selectedGateway?.depositSettings?.max}`,
          },
        ],
      },
    });
    setErrors(validations);
    return validations;
  };

  const getIfDefaultValue = ({ data }) => {
    let updatedData = { ...data };
    selectedGateway?.fields.forEach((f) => {
      if (!Boolean(data[f?.accessor]) && Boolean(f?.value)) {
        updatedData[f?.accessor] = f?.value;
      }
    });
    return updatedData;
  };

  const validateBankFormData = (data) => {
    const { amount, utrNo, txnImage } = data;
    let errorVar = {};
    if (!amount) {
      errorVar.amount = "Amount is required";
    }
    if (!utrNo) {
      errorVar.utrNo = "UTR is required";
    }
    if (!txnImage) {
      errorVar.txnImage = "Txn image is required";
    } else if (txnImage && txnImage?.size > 2000000) {
      errorVar.txnImage = "Image size must be less than 2MB";
    }
    setErrors(errorVar);
    return errorVar;
  };

  const handleChange = (e, type = "non-file") => {
    let name = e.target.name;
    let value = e.target.value;
    if (type === "file") {
      value = e.target.files?.[0];
    }
    let data = { ...formData, [name]: value };
    if (isBank) {
      validateBankFormData(data);
    } else {
      validateData(data);
    }

    setFormData(data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isBank) {
      if (Object.values(validateData({ ...formData })).length == 0) {
        setDisable(true);
        if (
          selectedGateway?.fields.some(
            (f) => f?.accessor === "gateway" && f?.required === true,
          )
        ) {
          formData["gateway"] = selectedGateway?.code;
        }
        if (selectedGateway?.slug && selectedGateway?.slug !== null) {
          formData.slug = selectedGateway?.slug;
        }

        const dataWithDefaultValues = getIfDefaultValue({ data: formData });

        const response = await updateDepositAmount({
          data:
            selectedGateway?.url.indexOf("dynamicmanual") > -1
              ? {
                  amount: dataWithDefaultValues.amount,
                  slug: dataWithDefaultValues.slug,
                  dynamicFields: dataWithDefaultValues,
                }
              : dataWithDefaultValues,
          url: selectedGateway?.url,
          isMultiPart: selectedGateway?.fields.some(
            (f) => f?.type === "file" || f?.type === "image",
          ),
        });

        handleSubmitResponse(response);
        setDisable(false);
      }
    } else {
      if (Object.values(validateBankFormData(formData)).length === 0) {
        setDisable(true);
        createDeposit(formData)
          .then((res) => {
            setDisable(false);
            Toaster(APP_CONST.TOAST_TYPE.SUCCESS, res.data.data.message);
          })
          .catch((err) => {
            setDisable(false);
            Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response.data.message);
          });
      }
    }
  };

  //TODO  Add it for url
  const handleSubmitResponse = (value) => {
    if (value) {
      if (
        selectedGateway?.url.indexOf("dynamicmanual") > -1 &&
        value?.data?.data
      ) {
        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Request created");
        setTimeout(() => {
          // window.location.reload();
        }, 1000);
      }
      if (selectedGateway.type === "manual") {
        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, value.data.data.message);
      } else if (value?.data?.data?.data && "payUrl" in value?.data.data.data) {
        // Redirect url
        window.location.href = value?.data?.data?.data?.payUrl;
      } else if (
        value?.data?.data?.data &&
        "payImageUrl" in value?.data.data.data
      ) {
        // Show image
        setCustomActionDepositResponse(value?.data?.data?.data?.payImageUrl);
        setCustomDepositResponseType(CUSTOM_DEPOSIT_RESPONSE_TYPE.IMAGE);
      } else if (
        value?.data?.data?.data &&
        "qrContent" in value?.data.data.data
      ) {
        // Show qr code
        setCustomActionDepositResponse(value?.data?.data?.data?.qrContent);
        setCustomDepositResponseType(CUSTOM_DEPOSIT_RESPONSE_TYPE.QRCODE);
      } else if (value?.data?.data?.data && "url" in value?.data.data.data) {
        // Redirect url
        window.location.href = value?.data?.data?.data?.url;
      } else if (selectedGateway.code === "alphapo") {
        window.location.href = value?.data?.data?.data?.url;
      } else if (selectedGateway.code === "coinbase") {
        window.location.href = value?.data?.data?.data?.url;
      }
    }
  };

  const renderFields = (field) => {
    switch (field.type) {
      case "file":
      case "image":
        return (
          <Form.Group
            className="mb-3 position-relative"
            controlId="formBasicUserName"
          >
            <Form.Control
              type={"file"}
              placeholder={field.label}
              name={field.accessor}
              onChange={(e) => handleChange(e, "file")}
              style={{ display: !field.display ? "none" : "" }}
              isInvalid={!!errors[field.accessor]}
            />
            <span className="focus-border">
              <i></i>
            </span>
            <Form.Control.Feedback type="invalid">
              {errors[field.accessor]}
            </Form.Control.Feedback>
          </Form.Group>
        );
      default:
        return (
          <Form.Group
            className="mb-3 position-relative"
            controlId="formBasicUserName "
          >
            <Form.Control
              type={field.type}
              value={
                !Boolean(formData?.[field?.accessor]) &&
                formData?.[field?.accessor] !== "" &&
                field?.value
                  ? field?.value
                  : formData?.[field?.accessor] || ""
              }
              placeholder={field.label}
              name={field.accessor}
              onChange={handleChange}
              style={{ display: !field.display ? "none" : "" }}
              isInvalid={!!errors[field.accessor]}
            />
            <span className="focus-border">
              <i></i>
            </span>
            <Form.Control.Feedback type="invalid">
              {errors[field.accessor]}
            </Form.Control.Feedback>
          </Form.Group>
        );
    }
  };

  const renderBankTransferForm = () => {
    return (
      <Form className="gatewayForm">
        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"number"}
            placeholder={"Enter amount"}
            name={"amount"}
            onChange={(e) => handleChange(e)}
            // style={{ display: !field.display ? "none" : "" }}
            isInvalid={!!errors["amount"]}
          />
          <span className="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {errors["amount"]}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"text"}
            placeholder={"Enter UTR no"}
            name={"utrNo"}
            onChange={(e) => handleChange(e)}
            // style={{ display: !field.display ? "none" : "" }}
            isInvalid={!!errors["utrNo"]}
          />
          <span className="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {errors["utrNo"]}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"file"}
            placeholder={"Select file"}
            name={"txnImage"}
            onChange={(e) => handleChange(e, "file")}
            // style={{ display: !field.display ? "none" : "" }}
            isInvalid={!!errors["txnImage"]}
          />
          <span className="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {errors["txnImage"]}
          </Form.Control.Feedback>
        </Form.Group>
        <Button onClick={handleSubmit}>Submit</Button>
      </Form>
    );
  };
  const renderCustomActionResponse = () => {
    if (customdepositResponseType === CUSTOM_DEPOSIT_RESPONSE_TYPE.IMAGE) {
      return (
        <div>
          <div className="ml-4 ">
            <div className="bg-zinc-50 rounded-lg p-3 qrSize">
              <img src={customActionDepositResponse} />
            </div>
          </div>
        </div>
      );
    } else if (
      customdepositResponseType === CUSTOM_DEPOSIT_RESPONSE_TYPE.QRCODE
    ) {
      return (
        <div>
          <QRCodeCard text={customActionDepositResponse} />
        </div>
      );
    } else {
      return null;
    }
  };
  return (
    <>
      {isDemoUser && <Navigate to="/" />}
      <HeaderAfterLogin />
      {customActionDepositResponse && customdepositResponseType ? (
        <>
          <div className="HpaySection">
            <div
              className="HayQR"
              onClick={() => {
                setCustomActionDepositResponse(null);
                setCustomDepositResponseType(null);
              }}
            >
              <img src={CrossBtn} alt="CrossBtn" />
            </div>
            {renderCustomActionResponse()}
          </div>
        </>
      ) : (
        <main className="main Deposit-Gateway-heading">
          {!isBank ? (
            <Container>
              <div className=" pagesHeading">
                {" "}
                <a className="back-link" onClick={() => navigate(-1)}>
                   <BackIcon />
                </a>
                <h2>{selectedGateway?.name}</h2>
                {" "}
              </div>
              <DisplayValues
                displayItems={selectedGateway?.depositDisplayFields || []}
              />
              {selectedGateway?.type === "manual" &&
                selectedGateway?.url.indexOf("dynamicmanual") < 0 && (
                  <>
                    <div className="valuesDeposit">
                      {/* <h3>Wallet : {selectedGateway?.value}</h3> */}
                      <div className="valueDepositName">
                        <h3>UPI :</h3>
                        <span>
                          {selectedGateway?.displayValue}
                          <div className="copyValue">
                            <CopyToClipboard
                              text={selectedGateway?.displayValue}
                              onCopy={() => {
                                Toaster(
                                  APP_CONST.TOAST_TYPE.SUCCESS,
                                  "Text Copied",
                                );
                              }}
                            >
                              <AiFillCopy />
                            </CopyToClipboard>
                            {/* <div>Click to copy code</div> */}
                          </div>
                        </span> 

                        
                      </div>
                    </div>
                    {(selectedGateway?.showQr === true && (
                      <div className="d-flex UPI-Image">
                        {showQrImg ? (
                          <div className=" mx-auto  w-full max-w-[12rem]  relative">
                            <div className="ml-4 ">
                              <div className="bg-zinc-50 rounded-lg p-3 qrSize">
                                <img src={selectedGateway?.qrCode} />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <QRCodeCard text={selectedGateway?.value} />
                        )}
                      </div>
                    )) ||
                      null}
                  </>
                )}

              <Form className="gatewayForm">
                {selectedGateway?.fields?.map((f, i) => {
                  return renderFields(f);
                })}
                <span className="focus-border">
                  <i></i>
                </span>
                <Button onClick={handleSubmit} disabled={disable}>
                  {!disable ? (
                    "Submit"
                  ) : (
                    <div>
                      <img
                        src={load}
                        style={{ width: "25px", height: "auto" }}
                      />
                    </div>
                  )}
                </Button>
              </Form>
            </Container>
          ) : (
            <Container>
              <div className="pagesHeading">
                <a className="back-link" onClick={() => navigate(-1)}>
                   <BackIcon />
                </a>
                <h2 className="sectionTitle border-0">{"Bank Transfer"}</h2>
                
              </div>
              {bankDetails && (
                <div className="display-values-section">
                  <p>
                    <h5>Account name :</h5> 
                    <span>
                      {bankDetails?.acc_name}{" "}

                      <CopyToClipboard
                        text={bankDetails?.acc_name}
                        onCopy={() => {
                          Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                        }}
                      >
                        <AiFillCopy />
                      </CopyToClipboard>

                    </span>
                    
                    {/* <CopyToClipboard
                    text={bankDetails?.acc_name}
                    onCopy={() => {
                      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                      console.log("Abc");
                    }}
                  /> */}
                  </p>
                  <p>
                    <h5>Account number :</h5> 
                    <span>
                      {bankDetails?.acc_no}{" "}
                      <CopyToClipboard
                        text={bankDetails?.acc_no}
                        onCopy={() => {
                          Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                        }}
                      >
                        <AiFillCopy />
                      </CopyToClipboard>
                    </span>
                    
                    {/* <CopyToClipboard
                    text={bankDetails?.acc_no}
                    onCopy={() => {
                      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                    }}
                  /> */}
                  </p>
                  <p>
                    <h5>IFSC code :</h5> 
                    <span>
                      {bankDetails?.ifsc_code}{" "}
                      <CopyToClipboard
                        text={bankDetails?.ifsc_code}
                        onCopy={() => {
                          Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                        }}
                      >
                        <AiFillCopy />
                      </CopyToClipboard>
                    </span>
                    
                    {/* <CopyToClipboard
                    text={bankDetails?.ifsc_code}
                    onCopy={() => {
                      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                    }}
                  /> */}
                  </p>
                  <p>
                    <h5>Bank name :</h5> 
                    <span>
                      {bankDetails?.bank_name}{" "}
                      <CopyToClipboard
                        text={bankDetails?.bank_name}
                        onCopy={() => {
                          Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                        }}
                      >
                        <AiFillCopy />
                      </CopyToClipboard>
                    </span>
                     
                    {/* <CopyToClipboard
                    text={bankDetails?.bank_name}
                    onCopy={() => {
                      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                    }}
                  /> */}
                  </p>
                </div>
              )}
              {bankDetails && renderBankTransferForm()}
            </Container>
          )}
        </main>
      )}
      {/* <Footer /> */}
    </>
  );
};
export default DepositGateway;
